import { Modal, ModalProps } from 'antd';
import React, { useImperativeHandle, useRef, useState } from 'react';

interface IPayload extends Omit<ModalProps, 'onOk' | 'onCancel' | 'footer' | 'open' | 'loading' | 'confirmLoading'> {
  onSave?(): Promise<void> | void;
  onCancel?(): void;
  component?: JSX.Element;
  additionButton?: Array<JSX.Element>;
  [key: string]: any;
}

export interface HModalRef {
  onOpen: (payload: IPayload) => void;
  onClose: () => void;
  mask: () => void;
  unmask: () => void;
}

type IProps = Omit<
  ModalProps,
  'open' | 'loading' | 'footer' | 'title' | 'width' | 'confirmLoading' | 'onOk' | 'onCancel'
>;

const HModal = React.forwardRef<HModalRef, IProps>((props, ref) => {
  const payloadRef = useRef<IPayload>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);

  useImperativeHandle(
    ref,
    () => ({
      onOpen: (payload) => {
        payloadRef.current = payload;
        setOpen(true);
      },
      onClose: () => {
        setOpen(false);
      },
      mask: () => setLoading(true),
      unmask: () => setLoading(false),
    }),
    [],
  );

  return (
    <React.Fragment>
      <Modal
        {...props}
        {...payloadRef.current}
        footer={payloadRef.current.additionButton}
        open={open}
        okText={payloadRef.current.okText || props.okText || 'Save'}
        cancelText={payloadRef.current.cancelText || props.cancelText || 'Cancel'}
        loading={loading}
        confirmLoading={confirmLoading}
        destroyOnHidden
        styles={{ body: { overflowY: 'auto', maxHeight: 'calc(100vh - 250px)' } }}
        onOk={async () => {
          setConfirmLoading(true);
          await payloadRef.current.onSave?.();
          setConfirmLoading(false);
        }}
        onCancel={() => {
          setOpen(false);
        }}
      >
        {payloadRef.current.component}
      </Modal>
    </React.Fragment>
  );
});

export default HModal;
